import api from '../../api/index.api'
import ReportTypes from './report.types'

export const onGetReports = (page = 0, paramsOrCb = {}, cb) => async dispatch => {
	let params = {}
	let callback
	if (typeof paramsOrCb === 'function') {
		callback = paramsOrCb
	} else {
		params = paramsOrCb || {}
		callback = cb
	}
	try {
		const result = await api.reportApi.getAllReport(page, params)
		result.page = page + 1
		dispatch({
			type: ReportTypes.GET_REPORTS,
			payload: result,
		})
		callback && callback(true, result)
	} catch (err) {
		console.log(err)
		callback && callback(false, err.message)
	}
}
